<template>
  <div
    class="pa-0 ma-0 fill-height"
    style="background-color:#F4F4F4;"
    fluid
  >
    <v-main>
      <v-card class="ma-0 pa-0" tile flat color="secondary">
        <v-row justify="center" class="px-0 pt-3 pb-0">
          <v-col cols="12">
            <v-card dark color="secondary" tile flat max-width="1080px" class="mx-auto pa-9">
              <v-card-title class="pl-0 ml-0 pb-9">
                <span class="pl-0">
                  <a href="https://tendertrace.com" target="_blank">
                    <v-img
                      src="@/assets/img/logo-white.png"
                      max-height="100"
                      contain
                      class="pl-0 ml-0"
                    >
                    </v-img>
                  </a>
                </span>
              </v-card-title>
              
              <div v-if="loading" class="text-center py-8">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                <p class="title mt-4 font-weight-light">Processing your request...</p>
              </div>

              <div v-else-if="error" class="py-8">
                <h2 class="display-3 mb-4">Unable to process request</h2>
                <p class="title mt-3 font-weight-light">{{ errorMessage }}</p>
                <div class="mt-4">
                  <p class="body-1">If you continue to experience issues, please contact support or visit your 
                    <router-link class="editor-link" to="/">user profile</router-link> to manage your email preferences.
                  </p>
                </div>
              </div>

              <div v-else-if="success" class="py-8">
                <h2 class="display-3 mb-4">Unsubscribed</h2>
                <p class="title mt-3 font-weight-light">
                  You have been unsubscribed from receiving market intelligence updates from Tendertrace. 
                  Visit your user profile to switch this back on.
                </p>
                <div class="mt-6">
                  <v-btn
                    color="primary"
                    large
                    @click="goToHome"
                    class="mr-3"
                  >
                    Go to Home
                  </v-btn>
                  <v-btn
                    outlined
                    large
                    @click="goToProfile"
                  >
                    User Profile
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-main>
  </div>
</template>

<script>
import { updateEmailPreferences } from "@/components/APIManager.js";

export default {
  name: "Unsubscribe",
  data() {
    return {
      loading: true,
      success: false,
      error: false,
      errorMessage: ""
    };
  },
  mounted() {
    this.processUnsubscribe();
  },
  methods: {
    async processUnsubscribe() {
      try {
        // Get token and send_emails from query parameters
        const token = this.$route.query.token;
        const send_emails = this.$route.query.send_emails === 'false' ? false : true;

        if (!token) {
          this.error = true;
          this.errorMessage = "Invalid unsubscribe link. Missing token.";
          this.loading = false;
          return;
        }

        // Make API call to update email preferences
        await updateEmailPreferences(send_emails, token);
        
        this.success = true;
        this.loading = false;
      } catch (error) {
        console.error("Error processing unsubscribe:", error);
        this.error = true;
        this.loading = false;
        
        if (error.response) {
          // Server responded with error
          if (error.response.status === 401) {
            this.errorMessage = "This unsubscribe link is invalid or has expired. Please request a new one or visit your user profile to manage your email preferences.";
          } else if (error.response.status === 404) {
            this.errorMessage = "User not found. Please contact support if you believe this is an error.";
          } else {
            this.errorMessage = "An error occurred while processing your request. Please try again later or contact support.";
          }
        } else if (error.request) {
          // Request was made but no response received
          this.errorMessage = "Unable to connect to the server. Please check your internet connection and try again.";
        } else {
          // Something else happened
          this.errorMessage = "An unexpected error occurred. Please try again later.";
        }
      }
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    },
    goToProfile() {
      // Navigate to user profile page (will redirect to login if not authenticated)
      this.$router.push({ name: 'user' });
    }
  }
};
</script>

<style scoped>
.editor-link {
  border-color: rgb(255, 190, 10);
  border-bottom-width: 1px;
  border-bottom-style: solid;
  color: inherit !important;
}
</style>
